/**
 * ********************************************************************************************************************
 * Responsibility - Displays the current progress of the review process in the form of bar. Aso provides a modal where
 * the user can copy the link to share the proof. 🐺
 * ************************************************
 *
 * @format
 */

import {
    DESIGN_STATUS_NOT_REVIEWED,
    PROOF_STATUS_PENDING,
    PROOF_STATUS_APPROVED,
    PROOF_STATUS_DISAPPROVED
} from 'frontier-constants';
import {Modal, ModalHeader, ModalFooter, Toast, StatusTag} from '@sttark/design-system';
import {useProofingContext} from '../proofing_context_provider';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {If} from 'frontier-utilities';
import React, {useState} from 'react';

// styles
import './review_progress.scss';

export const ReviewProgress = props => {
    const {className} = props;

    const proofCtx = useProofingContext();

    const {designsOrders, currentProof, shareLink, error} = proofCtx.data;

    const [isToastOpen, setIsToastOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleToggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    let currentReviewedCount = designsOrders.filter(d => d.status > DESIGN_STATUS_NOT_REVIEWED);
    currentReviewedCount = currentReviewedCount.length;

    let percentageReviewed = (currentReviewedCount / designsOrders.length) * 100;
    percentageReviewed = `${percentageReviewed.toFixed(2)}%`;
    const designCount = designsOrders.length;

    const isComplete =
        currentProof.status === PROOF_STATUS_APPROVED ||
        currentProof.status === PROOF_STATUS_DISAPPROVED;
    const isIncomplete = currentProof.status === PROOF_STATUS_PENDING;

    return (
        <div className={`progress-83kl ${className}`}>
            <Toast
                autoHide
                onClose={() => setIsToastOpen(false)}
                isOpen={isToastOpen}
                zIndex={3001}>
                <p className="color-structure-white m-0">Link copied to clipboard</p>
            </Toast>

            <Modal
                className="progress-83kl"
                onClose={handleToggleModal}
                isOpen={isModalOpen}
                zIndex={3000}
                bodyHeightAuto>
                <ModalHeader>Share Proof</ModalHeader>
                <div className="progress-83kl__content">
                    <p>Copy your link below to start sharing</p>
                    <h4>Share via link</h4>
                    <CopyToClipboard text={shareLink} onCopy={() => setIsToastOpen(true)}>
                        <div className="content-83kl__sharelink d-flex align-items-center justify-content-start">
                            <i className="fa fa-copy me-2 color-accent-primary" />
                            <p className="m-0">{shareLink}</p>
                        </div>
                    </CopyToClipboard>
                </div>

                <ModalFooter />
            </Modal>

            <div className="w-100 d-flex align-items-center justify-content-between">
                <div className={'progress-83kl__container'}>
                    <div
                        className={
                            'progress-83kl__label d-flex align-items-end justify-content-start'
                        }>
                        <h6>Proof Completion:</h6>
                        <span>
                            {currentReviewedCount}/{designCount}
                        </span>
                        <span className="color-structure-dark">
                            ({designCount} {designCount === 1 ? 'Design' : 'Designs'} for review)
                        </span>
                    </div>

                    <div className="progress-83kl__bar-container">
                        <div
                            className="progress-83kl__bar"
                            style={{width: percentageReviewed}}></div>
                    </div>
                </div>

                {/* share link and oder status*/}
                <div className="progress-83kl__share-link-and-status d-flex align-items-center">
                    <button
                        className="color-accent-primary d-flex align-items-center justify-content-start"
                        onClick={handleToggleModal}>
                        <u>
                            <i className="fa fa-envelope me-2" />
                            <span>Share proof</span>
                        </u>
                    </button>
                    <If condition={isIncomplete}>
                        <StatusTag type="warning" label="Proof Incomplete" />
                    </If>
                    <If condition={isComplete}>
                        <StatusTag type="success" label="Proof Complete" />
                    </If>
                </div>
            </div>

            {error && <ErrorDisplay className="alert alert-danger" error={error} />}
        </div>
    );
};
